import { useUnit } from 'effector-react';
import {
  Alert,
  AlertTitle,
  IconButton,
  SnackbarCloseReason,
  Typography,
} from '@mui/material';
import { Close, ContentCopy } from '@mui/icons-material';
import type { Notification as NotificationType } from '@entities/notification/types';
import { ThemeAdapter } from '@shared/theme/adapter';
import {
  $notification,
  $notifications,
  hideNotification,
  NotificationGate,
} from '../../model';
import * as Styled from './styled';

export const Notification = () => {
  const [notification, notifications] = useUnit([$notification, $notifications]);

  const handleClose =
    (item: NotificationType) => (_: unknown, reason: SnackbarCloseReason) => {
      if (reason === 'clickaway') {
        return;
      }
      hideNotification(item);
    };

  const handleCloseClick = (item: NotificationType) => () => {
    hideNotification(item);
  };

  const handleCopy = (code: string) => () => {
    navigator.clipboard.writeText(code);
  };

  return (
    <>
      <NotificationGate />

      <ThemeAdapter>
        <Styled.Stack>
          {notifications.map((item) => (
            <Styled.Snackbar
              key={item.id}
              open={notification?.id === item.id}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              autoHideDuration={!item.action && !item.code ? 3000 : null}
              onClose={handleClose(item)}
            >
              <Alert
                severity={item.severity}
                variant={item.variant}
                action={
                  (item.action || item.code) && (
                    <>
                      {item.action}
                      <IconButton
                        color="inherit"
                        size="small"
                        onClick={handleCloseClick(item)}
                        aria-label="close"
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </>
                  )
                }
              >
                {item.title && <AlertTitle>{item.title}</AlertTitle>}
                {item.label}
                {item.code && (
                  <Styled.CodeWrapper>
                    {item.code}
                    <IconButton
                      onClick={handleCopy(item.code)}
                      size="small"
                      color="inherit"
                    >
                      <ContentCopy fontSize="small" />
                    </IconButton>
                  </Styled.CodeWrapper>
                )}
              </Alert>
            </Styled.Snackbar>
          ))}
        </Styled.Stack>
      </ThemeAdapter>
    </>
  );
};
